// removed by extract-text-webpack-plugin
module.exports = {"confirmed":"app-pages-Employees-Staff-StaffList-EmailStatus-__EmailStatus___3NjyG","resend":"app-pages-Employees-Staff-StaffList-EmailStatus-__EmailStatus___1tj1z"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Employees/Staff/StaffList/EmailStatus/EmailStatus.css
// module id = 2340
// module chunks = 0